export const isMobile = () =>
	/android|ip(hone|ad|od)/i.test(window.navigator.userAgent)
